import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { translate } from '../../services/translate';
import moment from 'moment';
import { useFocusEffect, useIsFocused } from '@react-navigation/native';
import DeleteModal from '../../components/DeleteModal';
import { centralAPI } from '../../services/central-api';
import MyDataTable from '../../components/MyDataTable';
import Badge from '../../components/Badge';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Card from '../../components/Card';
import DataTableHeader from '../../components/DataTableHeader';
import DataTableContainer from '../../components/DataTableContainer';
import DropdownButton from '../../components/DropdownButton';

export default function Sessions({ navigation }: { navigation: Navigation; authenticatedUser?: AuthenticatedUser; }) {
    const { theme } = useStyles(styleSheet);
    const [sessions, setSessions] = useState<Session[]>([]);
    const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
    const [selectedSession, setSelectedSession] = useState<Session>();

    const isFocused = useIsFocused();
    useFocusEffect(useCallback(() => {
        if (isFocused) {
            getSessions();
        }
    }, [isFocused, navigation]));

    async function getSessions() {
        try {
            const response = await centralAPI.getOwnUserSessions();
            setSessions(response);
        } catch (err) {
            console.error(err);
        }
    }

    async function deleteSession(sessionId: number) {
        try {
            await centralAPI.deleteOwnUserSession(sessionId);
            await getSessions();
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <Container>
            <Header
                title={translate('sessions')}
            />
            <Card>
                <DataTableHeader
                    title={translate('sessionHistory')}
                    zIndex={2}
                />
                <DataTableContainer
                    dataTable={<MyDataTable
                        columns={[
                            {
                                name: translate('deviceBrowser'),
                                selector: row => `${row.deviceOs}/${row.deviceBrowser}`,
                                wrap: true,
                            },
                            {
                                name: translate('mostRecentActivity'),
                                selector: row => moment(row.lastIteration).format('DD/MM/YYYY HH:mm:ss'),
                                wrap: true,
                            },
                            {
                                name: translate('situation'),
                                cell: row => {
                                    let text = translate(row.status);
                                    let backgroundColor = undefined;
                                    if (row.current) {
                                        backgroundColor = '#00BA39';
                                        text = translate('currentSession');
                                    }
                                    if (row.status == 'expired') {
                                        backgroundColor = theme.colors.primaryButton.disabledBackground;
                                    }
                                    return <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                        <Badge mode='ROUNDED' key={row.id} backgroundColor={backgroundColor}>
                                            {text}
                                        </Badge>
                                    </View>;
                                },
                                wrap: true,
                            },
                            {
                                button: true,
                                cell: row => <DropdownButton
                                    actions={[{
                                        content: translate('delete'),
                                        variant: 'danger',
                                        onPress: () => {
                                            setSelectedSession(row);
                                            setDeleteModalVisible(true);

                                        },
                                        omit: row.current,
                                    }]}
                                />
                            }
                        ]}
                        data={sessions}
                    />}
                />

            </Card>
            {/* Delete Modal */}
            <DeleteModal
                setModalVisible={setDeleteModalVisible}
                isModalVisible={isDeleteModalVisible}
                onSubmit={async () => {
                    if (selectedSession) {
                        await deleteSession(selectedSession.id);
                    }
                }}
            />
        </Container>
    );
}


const styleSheet = createStyleSheet(() => ({}));
